import { useNavigationState } from "@/zustand/NavigationState";
import { useSafeLiveQuery } from "@/indexedDB/hooks/useSafeLiveQuery";
import { getMessageByServerIdFromLocalDB } from "@/indexedDB/services/messages";

// TO DO => Check if this version of using live query is better for
// diff between loading(undefined) and not found(null)
// and remove query  for "" when activeThreadId is null
export function useActiveThread() {
  const activeThreadId = useNavigationState((state) => state.activeThreadId);

  return useSafeLiveQuery(async () => {
    if (!activeThreadId) {
      return null;
    }
    const message = await getMessageByServerIdFromLocalDB(activeThreadId);
    return message ?? null;
  }, [activeThreadId]);
}
